/*eslint-disable*/
import React from "react";
import { useParams} from "react-router-dom";

// hooks
import useGroup from "../../hooks/useGroup";

// components
import Error404 from "../../components/error404/Error404";
import PageHeader from "../../components/pageHeader"
import GroupInfo from "./components/groupInfo";
import LoadingSpinner from "../../components/loadingSpinner";

function ViewGroup() {
  const { groupId } = useParams()
  const { group, isGroupLoading } = useGroup(groupId);
  if ( isGroupLoading ) return <LoadingSpinner />;
  if (Object.keys(group).length === 0){
    return (
      <Error404 />
    )
  }
  return (
    <>
      <PageHeader title={group?.displayName} view={true}/>
      <GroupInfo group={group} />
    </>
  );
}

export default ViewGroup;
